import * as THREE from 'three'

import FlowField from '../class/FlowField.js'
import particlesShader from '../shader/particlesShader.js'

export default class Particles
{
  constructor(deerWoods, camera)
  {
    this.insideCount
    this.camera = camera

    this.setPositionFromMesh(deerWoods)
    this.setFlowfield()
    this.setGeometry()
    this.setMaterial()
    this.setPoints()

    this.setStaticGeometry()
    this.setStaticPoints()

    this.setParticlesSize()
  }

  setPositionFromMesh(deerWoods){
    const array = deerWoods.geometry.attributes.position.array

    this.insideCount = array.length
    this.positions = array
  }

  setFlowfield()
  {
    this.flowField = new FlowField(this.positions)
  }

  setGeometry()
  {
    this.geometry = new THREE.BufferGeometry()
    this.geometry.setAttribute('position', new THREE.BufferAttribute(this.positions, 3))
    this.geometry.setAttribute('aFboUv', this.flowField.fboUv.attribute)
  }

  setMaterial()
  {
    this.material = new THREE.ShaderMaterial({
      uniforms:
      {
        uFogStart: { value: 15 },
        uFogLenght: { value: 5 },
        uCameraPosition: { value: this.camera.position },
        uColor: { value: new THREE.Vector3(0, 0, 0) },
        uSize: { value: 30 * window.devicePixelRatio },
        uFBOTexture: { value: this.flowField.texture },
      },
      vertexShader: particlesShader.vertex,
      fragmentShader: particlesShader.fragment
    })
  }

  setPoints()
  {
    this.points = new THREE.Points(this.geometry, this.material)
  }

  // Static
  setStaticGeometry()
  {
    this.staticGeometry = new THREE.BufferGeometry()
    this.staticGeometry.setAttribute('position', new THREE.BufferAttribute(this.positions, 3))
  }

  setStaticPoints()
  {    
    this.staticPoints = new THREE.Points(
      this.staticGeometry,
      new THREE.PointsMaterial({
        color: 0x111111,
        size: 0.01,
      })
    )
  }

  setParticlesSize(){
    const sizes = new Float32Array(this.insideCount)

    for(let i = 0; i < this.insideCount; i++)
    {
      //sizes[i] = 0.15
      sizes[i] = 0.0001 * window.innerWidth
    }

    this.staticGeometry.setAttribute('aSize', new THREE.BufferAttribute(sizes, 1))
    this.geometry.setAttribute('aSize', new THREE.BufferAttribute(sizes, 1))
  }

  render()
  {
    this.flowField.update()
  }

  refresh(){
    // Reset FlowField
    this.flowField.dispose()
    this.setFlowfield()

    // Reset Particles
    this.setMaterial()
    this.points.material = this.material
  }
}